import LinkIcon from '@jetbrains/icons/link.svg'
import classNames from 'classnames'
import type {JSX} from 'react'
import {memo} from 'react'

import IconButton from '../../../IconButton/IconButton'

import styles from './BuildDependants.css'

const linkParams = new URLSearchParams()
linkParams.set('tab', 'dependencies')
type Props = {
  buildUrl?: string | null
  hasDependants?: boolean | null
  wrapperProps?: JSX.IntrinsicElements['span']
}

function BuildDependants({buildUrl, hasDependants, wrapperProps}: Props) {
  return (
    <span
      {...wrapperProps}
      className={classNames(wrapperProps?.className, {
        [styles.invisible]: !hasDependants,
      })}
    >
      <IconButton
        disabled={!hasDependants}
        icon={LinkIcon}
        href={`${buildUrl || ''}&${linkParams.toString()}`}
        title={'This build is used by other builds'}
      />
    </span>
  )
}

export default memo(BuildDependants)
